// extracted by mini-css-extract-plugin
module.exports = {"form":"FrontPageSearchForm_form__GDW57","input":"FrontPageSearchForm_input__VYexf","dual-input":"FrontPageSearchForm_dual-input__FymH6"};